import { useEffect, useState } from 'react';
import './ApplicationItemContent.css'
import { useNavigate, useParams } from 'react-router-dom';
import UpdateApplication from '../../components/UpdateApplication/UpdateApplication';
// import DeleteApplication from '../../components/DeleteApplication/DeleteApplication';
import { getPatentApplication } from '../../utilities/api/patentApplications';
import { getTrademarkApplication } from '../../utilities/api/trademarkApplications';
import PatentApplicationDetails from '../../components/PatentApplicationDetails/PatentApplicationDetails';
import TrademarkApplicationDetails from '../../components/TrademarkApplicationDetails/TrademarkApplicationDetails';

export default function ApplicationItemContent({ user, applicationType, isMobile, toggleNotifications }) {
    const [loading, setLoading] = useState(false)
    const [application, setApplication] = useState(null)
    const params = useParams()
    const navigate = useNavigate()

    const getApplicationData = async (applicationID) => {
        setLoading(true)
        try {
            if (applicationType === 'patent') {
                const data = await getPatentApplication(applicationID)
                setApplication(data)
            } else if (applicationType === 'trademark') {
                const data = await getTrademarkApplication(applicationID)
                setApplication(data)
            }
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }

    const handleBackButton = () => {
        navigate(-1)
    }

    const updateApplication = async (application) => {
        setApplication(application)
    }

    useEffect(() => {
        getApplicationData(params.applicationID)
        // eslint-disable-next-line
    }, [])


    if (!['admin', 'manager'].includes(user.userType)) {
        return (
            <div className='ApplicationItemContent unauthorized'>
                <strong className='text-center'>You are not authorized to view this page!</strong>
            </div>
        )
    }

    if (loading) {
        return (
            <div className='ApplicationItemContent loading'>
                <div className="spinner-border" role="status"></div>
            </div>
        )
    }

    if (!application) {
        return (
            <div className='ApplicationItemContent noApplication'>
                <strong>Application Not Found</strong>
            </div>
        )
    }

  return (
    <div className='ApplicationItemContent'>
        <button className='backButton' onClick={handleBackButton}>
            <svg width="8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 13L1 7L7 1" stroke="#1A5E9B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>&nbsp;&nbsp;Back</span>
        </button>
        <div className='mainSection'>
            <div className='topContent'>
                <div className='left'>
                    <div className='RPNumber'>
                        {application.RPNumber.toUpperCase()}
                    </div>
                    { application &&
                    <div 
                    className={`${application.driveFolderLocation ? 'driveLocation' : 'noDriveLocation'}`} 
                    title={application.driveFolderLocation ? 'View Drive Folder' : 'No Drive Folder Location'}
                    >
                        <a href={application.driveFolderLocation ? application.driveFolderLocation.trim() : '#'} rel="noreferrer" target='_blank'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                            </svg>
                        </a>
                    </div>
                    }
                </div>
                <div className='right'>
                    <button className='action updateApplication' title='Update Application' data-bs-toggle="modal" data-bs-target={`#updateApplicationModal`}>
                        <svg width="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.3924 23.4533C25.8971 23.4533 26.3076 23.8692 26.3076 24.3805C26.3076 24.8927 25.8971 25.3076 25.3924 25.3076H20.2192C19.7144 25.3076 19.3039 24.8927 19.3039 24.3805C19.3039 23.8692 19.7144 23.4533 20.2192 23.4533H25.3924ZM21.8048 9.63334L23.1411 10.6949C23.6891 11.1234 24.0544 11.6883 24.1794 12.2824C24.3236 12.9358 24.1698 13.5776 23.7372 14.1328L15.7769 24.4269C15.4116 24.8944 14.8732 25.1573 14.2963 25.1671L11.1238 25.206C10.9507 25.206 10.8065 25.0892 10.7681 24.9236L10.047 21.7974C9.92204 21.2228 10.047 20.6287 10.4123 20.171L16.0557 12.8667C16.1518 12.7498 16.3249 12.7313 16.4402 12.818L18.8149 14.7074C18.9687 14.834 19.1802 14.9022 19.4013 14.8729C19.8724 14.8145 20.1896 14.386 20.1416 13.9282C20.1127 13.6945 19.9974 13.4997 19.8435 13.3536C19.7955 13.3147 17.5362 11.5032 17.5362 11.5032C17.392 11.3864 17.3632 11.1721 17.4785 11.027L18.3726 9.86707C19.1994 8.80552 20.6415 8.70813 21.8048 9.63334Z" fill="#1A5E9B"/>
                            <rect x="1" y="1" width="33" height="33" rx="7" stroke="#1A5E9B" strokeOpacity="0.24" strokeWidth="2"/>
                        </svg>
                    </button>
                    <UpdateApplication user={user} applicationType={applicationType} application={application} updateApplication={updateApplication} toggleNotifications={toggleNotifications} />
                    {/* <button className='action deleteApplication' title='Delete Application' data-bs-toggle="modal" data-bs-target={`#deleteApplicationModal`}>
                        <svg width="35" viewBox="0 0 35 35" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <rect x="1" y="1" width="33" height="33" rx="7" stroke="#CA150C" strokeOpacity="0.24" strokeWidth="2"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M23.7366 15.3519C23.7366 15.0989 23.5313 14.8936 23.2783 14.8936H11.182C10.9281 14.8936 10.7237 15.0989 10.7237 15.3519C10.7237 16.2658 10.7072 17.1174 10.6916 17.9066C10.6238 21.3432 10.5788 23.6138 11.9676 25.0301C12.9539 26.0356 14.5737 26.4848 17.2201 26.4848C19.8692 26.4848 21.4917 26.0347 22.4808 25.0273C23.876 23.6046 23.832 21.3231 23.7669 17.8672C23.7522 17.089 23.7366 16.2502 23.7366 15.3519Z" fill="#CA150C"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M24.6313 11.847H20.8354C20.7978 11.2475 20.6319 10.4023 20.0351 9.71663C19.4044 8.99155 18.4603 8.62305 17.2283 8.62305C15.9972 8.62305 15.0531 8.99155 14.4224 9.71663C13.8256 10.4023 13.6588 11.2475 13.6212 11.847H9.82715C9.44765 11.847 9.13965 12.155 9.13965 12.5345C9.13965 12.914 9.44765 13.222 9.82715 13.222H24.6313C25.0108 13.222 25.3188 12.914 25.3188 12.5345C25.3188 12.155 25.0108 11.847 24.6313 11.847Z" fill="#CA150C"/>
                        </svg>
                    </button>
                    <DeleteApplication user={user} applicationType={applicationType} application={application} toggleNotifications={toggleNotifications} /> */}
                </div>
            </div>
            {(applicationType && application) &&
            <div className='applicationDetails'>
                {applicationType === 'patent' &&
                <PatentApplicationDetails application={application} isMobile={isMobile} />
                }
                {applicationType === 'trademark' &&
                <TrademarkApplicationDetails application={application} isMobile={isMobile} />
                }
            </div>
            }
        </div>
    </div>
  )
}
